export default {"src":"/_next/static/media/freetaxfile.2d6f6976.svg","height":30,"width":199,"blurWidth":0,"blurHeight":0};